import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
var __default__ = {
  name: 'ImpactDetail'
};
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: {
    ventureId: null,
    impactGoal: null
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var impactId = computed(function () {
      return parseInt(route.params.impact);
    });
    var impact = computed(function () {
      var _props$impactGoal$imp;
      return (_props$impactGoal$imp = props.impactGoal.impacts) === null || _props$impactGoal$imp === void 0 ? void 0 : _props$impactGoal$imp.find(function (e) {
        return e.id === impactId.value;
      });
    });
    return {
      __sfc: true,
      props: props,
      route: route,
      impactId: impactId,
      impact: impact
    };
  }
}));